
import { defineComponent, PropType, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'

interface Page {
	id: string
	name: string
}

export default defineComponent({
	props: {
		pages: {
			type: Array(Object) as PropType<Page[]>,
			default: [],
		},
	},
	setup({ pages }, { emit }) {
		const identity = useIdentity()
		const switchTab = (tabName : string) => {
			$('.content').hide()
			$(`#div_${tabName}`).show()

			switch (tabName) {
				case 'order': // 若是點選"訂單查詢"tab則進行訂單查詢
					checkOrder()
					break
			}

			emit('switchTab', tabName)
		}

		return {
			style: useCssModule(),
			identity,
			switchTab,
			pages,
		}
	}
})
